import {Form, Select} from "antd";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import { buildWeeklyRrule, getDays } from '../helpers/rrule';

const RruleDaySelect = ({
  rrule,
  initialDays,
  setSelectedDaysCount,
  postChange,
  postBlur,
  hasFeedback,
  name = "days",
  isRequired = false,
  placeholder = '',
  showLabel = true,
  className = "default-item-class",
  disabled = false
}) => {
  const { t } = useTranslation();

  const days = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

  const [selectedDays, setSelectedDays] = useState(
    initialDays?.length ? initialDays : (rrule ? getDays(rrule) : [])
  );

  const buildRrule = (values) => buildWeeklyRrule(values ?? []);

  const handleChange = (values) => {
    setSelectedDays(values);

    if (setSelectedDaysCount) {
      setSelectedDaysCount(values.length);
    }
    if (postChange) {
      postChange(buildRrule(values));
    }
  };

  const handleBlur = () => {
    if (postBlur) {
      postBlur(buildRrule(selectedDays));
    }
  };

  return (
    <Form.Item
      className={className}
      label={showLabel ? (placeholder.length ? placeholder : t("rrules.weekday")) : null}
      name={name}
      initialValue={selectedDays}
      hasFeedback={hasFeedback}
      rules={[
        {
          required: isRequired,
          message: t("schedules.rruleDayRequiredMessage"),
        },
      ]}
    >
      <Select
        mode={"multiple"}
        allowClear
        disabled={disabled}
        bordered
        placeholder={placeholder}
        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        onChange={handleChange}
        onBlur={handleBlur}
      >
        {days.map((day, index) => (
          <Select.Option key={day + index} value={day}>
            {t("rrules.byweekday." + day)}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default RruleDaySelect;
